import React from 'react';
import { Card, Placeholder, Row } from 'react-bootstrap';

interface IExploreCardSkeletonProps {
    isAgencyCard?: boolean;
}

export function ExploreCardSkeleton({ isAgencyCard = false }: IExploreCardSkeletonProps) {
    return (
        <Card className="h-100" aria-hidden="true">
            <Card.Body className="d-flex flex-column justify-content-between placeholder-glow">
                <div className="d-flex flex-column flex-md-row">
                    <div className="col-12 col-md-3">
                        <Placeholder className="skeleton skeleton-explore-image" />
                    </div>
                    <div className="ml-md-3 mt-3 mt-md-0 col">
                        <div className="d-flex align-items-start justify-content-between">
                            <Placeholder xs={9} className="skeleton skeleton-explore-title" />
                            <Placeholder className="skeleton skeleton-header-icon" />
                        </div>
                        <Placeholder className="skeleton skeleton-date d-block my-2" />
                        <Row className="align-items-center">
                            {Array.from({ length: 2 }).map((_, i) => (
                                <div key={i} className="col-6 my-1 d-flex align-items-center">
                                    <Placeholder className="skeleton skeleton-platform-icon" />
                                    <Placeholder className="skeleton skeleton-table-cell mx-2" />
                                    <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-sm" />
                                </div>
                            ))}
                        </Row>
                    </div>
                </div>

                <div className="mt-3">
                    <Placeholder className="skeleton skeleton-table-name d-block mb-2" />
                    {[12, 11, 7].map((width, i) => (
                        <Placeholder key={i} xs={width} className="skeleton skeleton-description-line d-block mb-2" />
                    ))}
                </div>

                <div className="mt-3">
                    <Placeholder className="skeleton skeleton-table-name d-block mb-2" />
                    <div className="d-flex">
                        {Array.from({ length: 3 }).map((_, i) => (
                            <Placeholder key={i} className="skeleton skeleton-icon m-1" />
                        ))}
                    </div>

                    {isAgencyCard && (
                        <div className="d-flex align-items-center w-100 mt-1">
                            <Placeholder className="skeleton skeleton-influencer-avatar" />
                            <Placeholder className="skeleton skeleton-table-name ml-2" />
                        </div>
                    )}

                    <div className="d-flex align-items-center justify-content-between mt-3">
                        {isAgencyCard ? (
                            <div className="d-flex align-items-center">
                                <Placeholder className="skeleton skeleton-table-name" />
                                <div className="d-flex align-items-center ml-2">
                                    {Array.from({ length: 5 }).map((_, i) => (
                                        <Placeholder
                                            key={i}
                                            className="skeleton skeleton-message-avatar"
                                            style={{ marginLeft: i > 0 ? -8 : 0 }}
                                        />
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <div className="d-flex align-items-center">
                                <Placeholder className="skeleton skeleton-influencer-avatar" />
                                <Placeholder className="skeleton skeleton-table-name ml-2" />
                            </div>
                        )}
                        <Placeholder className="skeleton skeleton-action-btn" style={{ width: 120, height: 38 }} />
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}
